module.exports = __webpack_public_path__ + "img/26_36.ff0cd4bf.png";